import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, num }) => (
  <div className="flex items-center gap-3 font-mono-p text-xs uppercase tracking-[0.25em] text-volt">
    {num && <span className="text-slate-400">{num}</span>}
    <span className="h-px w-8 bg-volt/60" />
    {children}
  </div>
);

export const SectionHeading = ({ children, className = "" }) => (
  <h2 className={`font-display text-4xl font-extrabold leading-[0.95] text-slate-900 sm:text-5xl lg:text-6xl ${className}`}>
    {children}
  </h2>
);
